/* 🤖 this file was generated by svg-to-ts*/
export const icoFileRemoveFilled: {
  name: 'file-remove-filled';
  data: string;
} = {
  name: 'file-remove-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.482 1.999a.97.97 0 01.619.2l.106.094 5.5 5.5a.979.979 0 01.295.726L20 20.002a2 2 0 01-1.85 1.995l-.15.005H6a2 2 0 01-1.995-1.85L4 20.001v-16a2 2 0 011.85-1.995L6 2.002l7.482-.003zM15 14H9l-.117.007A1 1 0 009 16h6l.117-.007A1 1 0 0015 14zM13 4v5h5l-5-5z" fill="#909090"/></svg>`
};
